const loadJitsiScript = (callback: any) => {
  const existingScript = document.getElementById('myPaystack')

  if (!existingScript) {
    const script = document.createElement('script')
    script.src = 'https://js.paystack.co/v1/inline.js' // URL for the third-party library being loaded.
    script.id = 'myPaystack' // e.g., googleMaps or stripe
    document.body.appendChild(script)

    script.onload = () => {
      if (callback) {
        callback()
      }
    }
  }

  if (existingScript && callback) {
    callback()
  }
}

export default loadJitsiScript
